import { FormGroup, FormControl, Validators } from '@angular/forms';

// core
import { FlagsHelper } from '../../../core/library/flags-helper';

// own module
import { JssNodeAbstract, JssAbstFlags } from './jss-tree-abstract';
import { JssTreeNodeType, FormLayout, JssTreeNodeObjectSubType } from './jss-types';
import { JssTreeLayout } from './jss-tree-layout';

export class JssTreeObject extends JssNodeAbstract {

   private _jssTypeObjectDetected = false;   // true: if detected during JSS parseing
   private _jssRequiredArray: string[] = [];
   protected _formGroup: FormGroup = null;
   protected _localPathRefRoot = false;      // true: local path root for '#'

   constructor(
      nodeName: string,
      protected _nodeObjectSubType: JssTreeNodeObjectSubType = 'OBJECT_BASE'
   ) {
      super(nodeName, 'OBJECT');
   }

   // getter/setter
   public get nodeObjectSubType(): string { return this._nodeObjectSubType; }
   public get formGroup(): FormGroup { return this._formGroup; }
   public set localPathRefRoot(root: boolean) { this._localPathRefRoot = root; }

   // JssTypeObject from JSON Schema
   public setJssTypeObjectDetected(): void { this._jssTypeObjectDetected = true; }
   public addJssRequiredRef(ref: string): void { this._jssRequiredArray.push(ref); }

   // add child
   public addChild(child: JssNodeAbstract): JssNodeAbstract {
      if (!child) {
         console.warn('Passed param: miss child');
      }
      this._children.push(child);
      child.parent = this;
      return child;
   }

   public findDirectChildByName(nodeName: string): JssNodeAbstract {
      for (const item of this._children) {
         if (item.nodeName === nodeName) {
            return item;
         } else if (item.nodeType === 'LAYOUT') {
            return (item as JssTreeLayout).findDirectChildByName(nodeName);
         }
      }
      return null;
   }

   // for all objects/layouts
   public reveFindLocalPathRootNode(): JssTreeObject {
      if (this._localPathRefRoot) {
         return this;
      }
      // // pass through
      for (const item of this._children) {
         if (item.nodeType === 'OBJECT') {
            const node = (item as JssTreeObject).reveFindLocalPathRootNode();
            if (node) { return node; }
         } else if (item.nodeType === 'LAYOUT') {
            const node = (item as JssTreeLayout).reveFindLocalPathRootNode();
            if (node) { return node; }
         }
      }
      return null;
   }

   public recveDumpJssTree(indent: string) {
      let s = indent + this._nodeName + '<' + this._nodeType + '>=';
      if (this.hasTitle()) {
         s += 'Title:' + this._title;
      }
      if (this.isRequired()) {
         s += ',<Requ>';
      }
      if (this._formGroup) {
         s += ',CtrlValue:ja';
      }
      console.log(s);

      // children
      for (const item of this._children) {
         item.recveDumpJssTree(indent + '  ');
      }
   }

   public reveFindChildByPath(pathFragments: string[]): JssNodeAbstract {
      // 'properties' in path -> children in object
      if (pathFragments[0] !== 'properties' || pathFragments.length <= 1) {
         console.warn('Miss properties or path ends unexpected');
         return null;
      }
      // skip 'properties'
      pathFragments = pathFragments.slice(1);

      // search direct childs
      const jssObj = this.findDirectChildByName(pathFragments[0]);

      // child do not exist
      if (!jssObj) {
         console.warn('Child not found');
         return null;
      }

      // voilá
      if (pathFragments.length === 1) {
         return jssObj;
      }

      // search next level
      return this.reveFindChildByPath(pathFragments.slice(1));
   }

   public recveGenFormTree(form: FormGroup = null) {
      // add to parent object if available
      if (form) {
         this._formGroup = new FormGroup({});
         form.addControl(this._nodeName, this._formGroup);
      }

      // pass through
      for (const item of this._children) {
         item.recveGenFormTree(this._formGroup);
      }
   }

   /**
   * Erzeugt ein JS Object mit dem Inhalt der Form sowie den Hidden-pass-through Daten.
   *
   * @param data: any
   * @returns void
   */
   public recveCreateDataObject(data: any) {

      // add key
      data[this.nodeName] = {};

      // pass through
      for (const item of this._children) {
         item.recveCreateDataObject(data[this.nodeName]);
      }
   }

   public recveEvalSchema(
      dump_output: boolean
   ) {
      if (this._jssRequiredArray.length > 0) {
         let child: JssNodeAbstract = null;
         for (const reqItem of this._jssRequiredArray) {
            child = this.findDirectChildByName(reqItem);
            if (!child) {
               console.warn('required key unknown: ' + reqItem);
            } else {
               child.required = true;

               // object -> reverse all children and set required flag
               if (child.nodeType === 'OBJECT') {
                  (child as JssTreeObject).reveSetAllChildrenRequiredFlag();
               }
            }
         }
      }

      // traverse children to check if 'required' ist defined in schema
      for (const item of this._children) {
         item.recveEvalSchema(dump_output);
      }
   }

   // traverse children and set 'required' flag (if object ist set to 'required')
   public reveSetAllChildrenRequiredFlag(): void {
      // all children
      for (const item of this._children) {
         // object
         if (item.nodeType === 'OBJECT') {
            (item as JssTreeObject).reveSetAllChildrenRequiredFlag();
         } else {
            // all but object
            item.required = true;
         }
      }
   }
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/jss-tree-object.ts